import { Component } from '@angular/core';

@Component({
  selector: 'app-account',
  imports: [],
  templateUrl: './account.component.html',
  styleUrl: './account.component.scss',
})
export class AccountComponent {

  public isEditing = false;

  public toggleEdit() {
    this.isEditing = !this.isEditing;
  }

}
